import { reactive } from "vue";

export const requestAssignmentStore = reactive({
  isAssigned: 0,
  isUnassigned: 0,
  legalTeamUpdated: 0,
  statusUpdated: 0,
  notesUpdated: 0,
  unassignRequestData: null,
  closingRequestData: null,
  invalidFiles: [] as string[],
  filesAttached: null,
  assignmentData: null,
  selectedDropdownRole: null,
  practitionerQueuePageNumber: 0,
  isFilterModalOpen: false,
  appliedFilters: null,
  filtersAppliedKey: 0,
  isSearchDrawerOpen: false,
  aiSearchQuery: "",
  aiSearchLoading: false,
  aiSearchResult: null as any,
  aiSearchError: null as string | null,
  /** Cached assignment-matrix rows for workbench service-catalogue filter (keyed by sorted group membership ids). */
  serviceCatalogueFilterCache: null as null | { membershipKey: string; teamIds: number[]; rows: any[] }
});
